import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["xlink:href"]

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'svgIcon',
  props: {
  name: {
    type: String,
    required: true
  },
  // 自定义宽度，支持数字（默认单位 px）和字符串（如 '24px', '2em'）
  width: {
    type: [Number, String],
    default: '1em'
  },
  // 自定义高度，支持数字（默认单位 px）和字符串
  height: {
    type: [Number, String],
    default: '1em'
  },
  // 自定义填充颜色
  fill: {
    type: String,
    default: undefined
  },
  // 自定义类名
  className: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props;

// 计算自定义样式
const customStyle = computed(() => {
  const style: any = {};

  if (props.width) {
    style.width = typeof props.width === 'number' ? `${props.width}px` : props.width;
  }

  if (props.height) {
    style.height = typeof props.height === 'number' ? `${props.height}px` : props.height;
  }

  if (props.fill) {
    style.fill = props.fill;
  }

  return style;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: "svg-icon",
    style: _normalizeStyle(customStyle.value)
  }, [
    _createElementVNode("use", {
      "xlink:href": `#icon-${props.name}`
    }, null, 8, _hoisted_1)
  ], 4))
}
}

})